import dynamic from 'next/dynamic';

const CompetitionFilters = dynamic(() =>
  import('./CompetitionFilters/CompetitionFilters')
);
const CompetitionGrid = dynamic(() =>
  import('./CompetitionGrid/CompetitionGrid')
);
export { CompetitionFilters, CompetitionGrid };
